import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { AddOperationApi } from "../../../api";
import { Link, useNavigate } from "react-router-dom";

export const OperationsAdd = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)


    const onFinishAdd = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await AddOperationApi(formRef)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت ثبت گردید", { type: "success" })
            navigate('/p/settings/operations');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }


    useEffect(() => {
        document.title = "افزودن عملیات | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 6, })
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">اضافه کردن عملیات خودکار</h1>

            <form ref={formRef} onSubmit={onFinishAdd} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-[33.33%] flex flex-col sm:flex-row items-center">
                        <div className=" w-full h-[50px] flex md:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CSelect name="action" placeholder={'انتخاب عملیات'} title="عملیات" border={true} required={true}>
                                    <option value={1}>تایید خودکار</option>
                                    <option value={2}>رد خودکار</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>
                    <div className=" w-full md:w-[33.33%]  flex flex-col sm:flex-row items-center">
                        <div className=" w-full h-[50px] flex md:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CSelect name="category" placeholder={'انتخاب دسته'} title="دسته بندی" border={true} required={true}>
                                    <option value={'3'}>تاخیرها</option>
                                    <option value={'1'}>مرخصی ها</option>
                                    <option value={'4'}>اضافه کاری های قبل از شیفت</option>
                                    <option value={'5'}>اضافه کاری های بعد از شیفت</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-[33.33%]  flex flex-col sm:flex-row items-center">
                        <div className=" w-full h-[50px] flex md:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CSelect name="period" placeholder={'انتخاب بازه'} title="بازه زمانی" border={true} required={true}>
                                    <option value={1}>5 دقیقه</option>
                                    <option value={2}>30 دقیقه</option>
                                    <option value={3}>1 ساعت</option>
                                    <option value={4}>8 ساعت</option>
                                    <option value={5}>1 روز</option>
                                    <option value={6}>7 روز</option>
                                    <option value={7}>15 روز</option>
                                    <option value={8}>30 روز</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/operations'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
